import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import logoVerticalWhite from '@/assets/logo-vertical-white.svg';

import styles from './MobileMenu.module.css';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  // Close menu on escape key and manage scroll lock
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      // Prevent scrolling on both html and body
      const scrollY = window.scrollY;
      document.documentElement.style.position = 'fixed';
      document.documentElement.style.top = `-${scrollY}px`;
      document.documentElement.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;
      
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      if (isOpen) {
        // Restore scroll position
        const scrollY = document.body.style.top;
        document.documentElement.style.position = '';
        document.documentElement.style.top = '';
        document.documentElement.style.width = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  return (
    <div className={`${styles.mobileMenuWrapper} ${isOpen ? styles.open : ''}`}>
      {/* Backdrop */}
      {isOpen && (
        <div
          className={styles.backdrop}
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      {/* Menu Panel */}
      <div className={`${styles.menuPanel} ${isOpen ? styles.open : ''}`}>
        <div className={styles.menuContent}>
          {/* Header */}
          <div className={styles.menuHeader}>
            <div className="flex items-center justify-between">
              <img 
                src={logoVerticalWhite} 
                alt="BlackRent Autoservis" 
                className="h-16"
              />
              <button
                onClick={onClose}
                className="p-2 text-gray-400 hover:text-white transition-colors"
                aria-label="Close menu"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          {/* Navigation Links */}
          <nav className={styles.menuNav}>
            <div className={styles.navItems}>
              <Link
                to="/"
                onClick={onClose}
                className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              >
                Domov
              </Link>
              <Link
                to="/cennik"
                onClick={onClose}
                className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              >
                Cenník
              </Link>
              <Link
                to="/nahradne-vozidla"
                onClick={onClose}
                className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              >
                Náhradné vozidlá
              </Link>
              {/* Galéria - skryté kým nemáme vlastné fotky */}
              {/* <Link
                to="/galerija"
                onClick={onClose}
                className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              >
                Galéria
              </Link> */}
              <Link
                to="/o-nas"
                onClick={onClose}
                className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              >
                O nás
              </Link>
              <Link
                to="/kontakt"
                onClick={onClose}
                className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              >
                Kontakt
              </Link>
              <Link
                to="/faq"
                onClick={onClose}
                className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              >
                FAQ
              </Link>

              {/* Divider */}
              <div className="h-px bg-white/10 my-4" />

              <Link
                to="/dashboard"
                onClick={onClose}
                className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              >
                Prihlásiť sa
              </Link>
            </div>
          </nav>

          {/* CTA Buttons */}
          <div className={styles.menuCta}>
            <Link
              to="/rezervacia"
              onClick={onClose}
              className="block w-full btn-primary text-center"
            >
              Rezervovať termín
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

